import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle, ArrowLeft } from "lucide-react";

export default function PaySuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    const MAX = 8;
    const poll = async (n) => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setDetail(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (n >= MAX) {
          setStatus("timeout");
          return;
        }
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        if (n >= MAX) {
          setStatus("error");
          return;
        }
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), 2000);
      }
    };
    poll(0);
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-carbon text-warm flex items-center justify-center px-6">
      <div
        className="max-w-lg w-full text-center bg-[#111111] border border-[#FAF9F6]/10 p-10 lg:p-14"
        data-testid="pay-success-card"
      >
        {status === "polling" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-[#C5A880]" />
            <h1 className="font-display text-3xl mt-6">
              Verifica del pagamento
            </h1>
            <p className="mt-3 text-sm text-[#FAF9F6]/60">
              Stiamo confermando la transazione ({attempts}/8)
            </p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2
              size={48}
              className="mx-auto text-emerald-400"
              data-testid="pay-success-icon"
            />
            <h1 className="font-display text-3xl mt-6">
              Pagamento confermato
            </h1>
            <p className="mt-3 text-sm text-[#FAF9F6]/65 leading-relaxed">
              Grazie. Riceverai il parere strutturato via email entro i
              termini concordati.
            </p>
            {detail && (
              <div className="mt-6 text-xs text-[#FAF9F6]/45 font-mono">
                Riferimento: {sessionId?.slice(0, 12)}...
              </div>
            )}
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle size={40} className="mx-auto text-red-400" />
            <h1 className="font-display text-3xl mt-6">
              {status === "expired"
                ? "Sessione scaduta"
                : status === "timeout"
                  ? "Verifica non completata"
                  : "Errore di verifica"}
            </h1>
            <p className="mt-3 text-sm text-[#FAF9F6]/65">
              Contatta lo studio per assistenza.
            </p>
          </>
        )}
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-[#C5A880] hover:text-[#D5B890]"
          data-testid="pay-success-back"
        >
          <ArrowLeft size={14} /> Torna al sito
        </Link>
      </div>
    </div>
  );
}
